import store from "../../store";
import {getUser} from "store/auth-slice";
import {getPermissionsByRole, getAllPermissions, getRolesAndPermissions} from "store/data-slice";
import _ from "lodash";

const permissions = {
    async action(requiredPermission) {
        let user = await store.dispatch(getUser());
        let sub_role = user.sub_role ? user.sub_role : 'viewer';

        let permissions = await this.getPermissions(user.role);
        // console.log('permissions.requireee:', user.sub_role, permissions[sub_role].permissions)
        //console.log(permissions, sub_role)
        if (permissions && permissions[sub_role] && permissions[sub_role].permissions) {
            // console.log('permissions.require (user):', permissions[sub_role].permissions);
            if (_.indexOf(permissions[sub_role].permissions, requiredPermission) > -1) {
                // console.log('permiss test:', requiredPermission, 'true')
                return true;
            }
        }
        // console.log('permiss test:', requiredPermission, 'false')
        return false;
    },

    async moduleExists(m) {
        const allPermissions = await store.dispatch(getAllPermissions());
        return allPermissions[m] !== undefined ? true : false;
    },

    async module(requiredModule) {
        return true;
    },

    async getPermissions(role) {
        let permissions = await store.dispatch(getPermissionsByRole(role, false));
        // console.log('>>>>perms', role, permissions)
        if(permissions !== null) {
            return permissions;
        }

        permissions = await store.dispatch(getPermissionsByRole(role,true));
        return permissions
    }
}

export default permissions;

